import { colors } from '@cobliteam/ui/theme';
import { css } from 'emotion';

export const popup = css`
  box-shadow: 2px 2px 10px 0 rgba(157, 169, 182, 0.2);
  border: 1px solid ${colors.gray[6]};
  border-radius: 5px;
  box-sizing: content-box;
  background-color: ${colors.white.DEFAULT};

  .leaflet-popup-content-wrapper {
    padding: 0;
    border-radius: inherit;
  }

  .leaflet-popup-content {
    margin: 0;
    border-radius: inherit;
  }
`;
